const OpenSource = () => {
  return (
    <div className="h-full flex justify-center items-center ">
      <div className="text-xl font-Roboto">
        <h1 className="text-center">Open Source</h1>
        <h1 className="text-center">Coming soon...</h1>
      </div>
    </div>
  );
};

export default OpenSource;
